import React from 'react';
import { ReactComponent as Menu } from '../../assets/icons/menu.svg';
import { ReactComponent as Close } from '../../assets/icons/close.svg';
import Logo from 'components/Logo/Logo';

import './Header.scss';

type HeaderComponentProps = {
  onShowNav?: () => void;
  showNav?: boolean;
};

function Header({ onShowNav, showNav }: HeaderComponentProps) {
  return (
    <div className="header">
      <div>
        <Logo showText={true} />
        <div className="header__menu--icon" onClick={() => onShowNav()}>
          {onShowNav && <>{showNav ? <Close className="header__menu--close" /> : <Menu />}</>}
        </div>
      </div>
    </div>
  );
}

export default Header;
